module.exports = __webpack_public_path__ + "static/media/logoDPCDark.4d23dae5.svg";